/* eslint-disable prettier/prettier */

// Create User Validation
export const validateFirstName = (firstName) => {
    if (!firstName) {
        return 'First Name is required.'
    }
    const regex = /^[A-Z][a-zA-Z.]{1,}(?: [a-zA-Z0-9-]*)*$/;

    if (!regex.test(firstName)) {
        return 'Name must start with a capital letter, have at least two characters, and spaces can only follow letters.';
    }
    return ''
}

export const validateLastName = (lastName) => {
    if (!lastName) {
        return 'Last Name is required.'
    }
    const regex = /^[A-Z][a-zA-Z.]{1,}(?: [a-zA-Z0-9-]*)*$/;

    if (!regex.test(lastName)) {
        return 'Name must start with a capital letter, have at least two characters, and spaces can only follow letters.';
    }
    return ''
}

export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email) {
        return 'Email is required.'
    } else if (!emailRegex.test(email)) {
        return 'Please enter a valid email address.'
    }
    return ''
}

export const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/;

    if (!phoneNumber) {
        return 'Phone number is required.';
    } else if (!phoneRegex.test(phoneNumber)) {
        return 'Invalid phone number format.';
    } else if (phoneNumber.length < 10 || phoneNumber.length > 15) {
        return 'Phone number must be between 10 and 15 digits.';
    } else if (/^0+$/.test(phoneNumber)) {
        return 'Invalid phone number.';
    }
    return '';
};


export const validatePassword = (password) => {
    const minLength = 8;

    if (!password) {
        return 'Password is required.';
    }
    if (password.length < minLength) {
        return `Password must be at least ${minLength} characters long.`;
    }
    if (!/[A-Z]/.test(password)) {
        return 'Password must contain at least one uppercase letter.';
    }
    if (!/[a-z]/.test(password)) {
        return 'Password must contain at least one lowercase letter.';
    }
    if (!/[0-9]/.test(password)) {
        return 'Password must contain at least one number.';
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        return 'Password must contain at least one special character (e.g., !, @, #, etc.).';
    }
    if (/\s/.test(password)) {
        return 'Password must not contain spaces.';
    }
    return '';
};


// Role Validation
export const validateRoleName = (roleName) => {
    if (!roleName.trim()) {
        return 'Role Name is required and cannot contain only spaces.';
    }

    const regex = /^[A-Z][a-zA-Z.]{1,}(?: [a-zA-Z0-9-]*)*$/;

    if (!regex.test(roleName)) {
        return 'Role Name must start with a capital letter, have at least two characters, and spaces can only follow letters.';
    }

    return '';
};


export const validateRoleCode = (roleCode) => {
    if (!roleCode) {
        return 'Role Code is required.'
    } else if (roleCode.length > 1) {
        return 'Role Code must be exactly 1 character or number..'
    } else if (!/^[a-zA-Z0-9]$/.test(roleCode)) {
        return 'Role Code must be a letter or number.';
    }
    return ''
}

// Title Validation
export const validateTitle = (title) => {
    if (!title.trim()) {
        return 'Title is required and cannot contain only spaces.';
    }

    const regex = /^[A-Z][a-zA-Z.]{1,}(?: [a-zA-Z0-9-]*)*$/;
    if (!regex.test(title)) {
        return 'Title must start with a capital letter, have at least two characters in the first word, and spaces can only follow valid words.';
    }

    return '';
};


// Leader Validation
export const validateName = (name) => {
    if (!name.trim()) {
        return "Name cannot be empty.";
    }

    const regex = /^[A-Z][a-zA-Z0-9.-]*(\s[A-Za-z][a-zA-Z0-9.-]*)*$/;

    if (!regex.test(name)) {
        return "Name must start with a capital letter, and spaces can only follow valid words.";
    }

    return "";
};

export const validateLeaderDesignation = (leaderDesignation) => {
    if (!leaderDesignation) {
        return 'Designation is required.'
    }
    const regex = /^[A-Z][a-zA-Z0-9.-]*(\s[A-Z][a-zA-Z0-9.-]*)*$/;

    if (!regex.test(leaderDesignation)) {
        return 'Designation name must start with a capital letter, have at least two characters in the first word, and spaces can only follow valid words.';
    }
    return ''
}


// Offices Validation

export const validateOfficeEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email) {
        return 'Email is required.'
    } else if (!emailRegex.test(email)) {
        return 'Please enter a valid email address.'
    }
    return ''
}

export const validateOfficeNumber = (phoneNumber) => {
    const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/;

    if (!phoneNumber) {
        return 'Phone number is required.';
    } else if (!phoneRegex.test(phoneNumber)) {
        return 'Invalid phone number format.';
    } else if (phoneNumber.length < 10 || phoneNumber.length > 15) {
        return 'Phone number must be between 10 and 15 digits.';
    }

    return '';
};

export const validateFullAddress = (officeAddress) => {
    if (!officeAddress) {
        return 'Address is required.'
    } else if (officeAddress.length < 4) {
        return 'Address must be at least 4 characters.'
    }
    return ''
}

export const validateLocation = (location) => {

    if (!location) {
        return 'Location is required.';
    }
    if (location.length < 2) {
        return 'Location must be at least 2 characters long.';
    }

    return '';
};


// Donation Validation

export const validateDonationCause = (donationCause) => {
    if (!donationCause) {
        return 'Donation Cause is required.'
    } else if (donationCause.length < 6) {
        return 'Donation Cause must be at least 6 characters.'
    }
    return ''
}

export const validateURL = (URL) => {
    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:[0-9]+)?(\/[^\s]*)?$/;

    if (!URL) {
        return 'URL is required.';
    }
    if (URL.length < 2) {
        return 'URL must be at least 2 characters long.';
    }
    if (!urlRegex.test(URL)) {
        return 'Donation URL must be a valid URL.';
    }
    return '';
};

// Award Validation
export const validateAwardBy = (awardBy) => {
    if (!awardBy) {
        return 'AwardBy is required.'
    } else if (awardBy.length < 4) {
        return 'AwardBy must be at least 4 characters.'
    }
    return ''
}

export const validateAwardYear = (awardYear) => {
    const yearRegex = /^[0-9]+$/;

    if (!awardYear) {
        return 'Award Year is required.';
    }
    if (!yearRegex.test(awardYear)) {
        return 'Award Year must not contain special characters or letters.';
    }
    if (awardYear.length !== 4) {
        return 'Award Year must be exactly 4 digits.';
    }
    return '';
};


export const validateShortName = (name) => {
    if (!name) {
        return 'Name is required.'
    } else if (name.length > 3) {
        return 'Name must be do not exceed 3 characters.'
    } else if (name[0] !== name[0].toUpperCase()) {
        return 'Name must start with a capital letter.'
    }
    return ''
}

export const validatePhoneCode = (phoneCode) => {
    // Define the regex pattern for phone codes (e.g., +1, +91, etc.)
    const phoneCodePattern = /^\+\d{1,3}$/; // Allows + followed by 1 to 3 digits

    if (!phoneCode) {
        return 'Phone code is required.';
    } else if (!phoneCodePattern.test(phoneCode)) {
        return 'Please enter a valid phone code (e.g., +1, +91).';
    }
    return '';
};

export const validateAnnualIncome = (annualIncome) => {
    const incomePattern = /^(\d{1,3}(,\d{3})*|\d+|(\d+|\d{1,3}(,\d{3})*)\s*lac)(-\s*(\d{1,3}(,\d{3})*|\d+|(\d+|\d{1,3}(,\d{3})*)\s*lac))?$/i;

    if (!annualIncome) {
        return 'Annual income is required.';
    } else if (!incomePattern.test(annualIncome)) {
        return 'Please enter a valid annual income (e.g., 50000, 50,000, 1 lac, 1 lac-5 lac, 50000-100000).';
    }
    return '';
};

export const validateReservationPercentage = (percentage) => {
    // Define the regex pattern for percentages (e.g., 0, 50, 100, 25.5, 99.99)
    const percentagePattern = /^(100(\.00?)?|[0-9]?[0-9](\.\d{1,2})?)$/;

    if (percentage === undefined || percentage === null || percentage === '') {
        return 'Reservation percentage is required.';
    } else if (!percentagePattern.test(percentage)) {
        return 'Please enter a valid reservation percentage (0-100, up to two decimal places).';
    }
    return '';
};

export const validateCountryCode = (countryCode) => {
    // Define the regex pattern for country codes (e.g., Australia-AU, India-IN)
    const countryCodePattern = /^[A-Za-z]+-[A-Z]{2}$/;

    if (!countryCode) {
        return 'Country code is required.';
    } else if (!countryCodePattern.test(countryCode)) {
        return 'Please enter a valid country code in the format CountryName-ISOCode (e.g., India-IN).';
    }
    return '';
};

